export const getDimensions = ({ x, y, w, h, newWidth }) => {
  const original_width = 600
  const scale = newWidth / original_width

  return {
    x: x * scale,
    y: y * scale,
    width: w * scale,
    height: h * scale,
  }
}

export const cleanUrl = (url: string) => {
  return url
    .replace(/^https?:\/\//, '') // Remove http:// or https://
    .replace(/^www\./, '') // Remove www.
    .replace(/\/$/, '') // Remove trailing slash
}
